import { Skeleton } from '@grupoboticario/barril-del-chavo'
import { Flex, ScrollArea, useIsMobile } from '@grupoboticario/flora-react'

const DEFAULT_MOBILE_SKELETON_QUANTITY = 3
const DEFAULT_DESKTOP_SKELETON_QUANTITY = 8
export const CategoryListSkeleton = () => {
  const isMobile = useIsMobile()
  const boxToShow = isMobile ? DEFAULT_MOBILE_SKELETON_QUANTITY : DEFAULT_DESKTOP_SKELETON_QUANTITY

  const skeletons = Array.from({ length: boxToShow }, (_, index) => (
    <Skeleton
      key={index}
      css={{ minWidth: '140px', height: '120px' }}
    />
  ))

  return (
    <Flex
      gap="$4"
      role="status"
      aria-live="polite"
      aria-label="Carregando as categorias"
      css={{ overflow: 'hidden', width: '100%', paddingTop: '$4' }}
    >
      {skeletons}
    </Flex>
  )
}
